module.exports = __webpack_public_path__ + "images/emoji/bath.546053018bebc2c82eed.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/bath.png
// module id = oJu3
// module chunks = 1